import crudlModuleGenerator from '@/_CRUDL/modules/generator';

export default crudlModuleGenerator('domains', {
  customKeys: {
    list: 'data',
  },
  customEndpoints: {
    list: `/${process.env.VUE_APP_BANKS_API_SUFFIX}/domains`,
  },
});
